























































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import _ from 'lodash'
import SlaFeriado from '@/model/resource/SlaFeriado'
import moment from 'moment'
import * as Helper from '@/helpers'

const metaInfo = () => ({
  title: $.t('view.persist.holidayPersist.title'),
})

@Component({
  metaInfo,
})
export default class HolidayPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  slaHoliday = new SlaFeriado()

  persistThrottled = _.throttle(() => this.persist(), 7000)

  get editMode() {
    return Boolean(this.id)
  }

  @Watch('slaHoliday.monthResource', {deep: true})
  handleDate() {
    this.slaHoliday.dia = Number(moment(this.slaHoliday.date).format('DD')) || 0
  }

  formatDesc() {
    if (this.slaHoliday.desc) {
      this.slaHoliday.desc = this.slaHoliday.desc.toUpperCase()
    }
  }

  async mounted() {
    if (this.id) await this.slaHoliday.getSlaFeriado(this.id)
    $.await.done('getSlaFeriado')
  }

  async persist() {
    if (this.slaHoliday.dia === 0) {
      await Helper.abort('system.error.emptyDay')
    }
    if (this.slaHoliday.mes === 0) {
      await Helper.abort('system.error.emptyMonth')
    }
    await this.slaHoliday.persistSlaFeriado()
    successAndPush('system.success.persist', '/manage/sla-holidays/list')
  }
}
